import { observer } from 'mobx-react-lite';
import { getCommandCategories, getCommands } from 'owa-calendar-hotkeys';
import { isBoardViewTypeSelected } from 'owa-calendar-module-store';
import { HotkeysMap } from 'owa-hotkeys-map';
import * as React from 'react';

export default observer(function CalendarModuleHotkeysMap() {
    const categories = getCommandCategories(isBoardViewTypeSelected());
    const commands = Object.values(getCommands());
    return (
        <HotkeysMap
            commandCategories={categories}
            hotkeyCommands={commands}
            firstColumnLength={2}
        />
    );
});
